import { redirectToLoginPage as webAuthRedirect } from '@driftt/web-auth'

import { isDev } from 'config/environment'
import {
  ABMNotification,
  ConversationNotification,
  ExternalNotification
} from 'notifications/typings/notifications'

import config from '../../config'
import NotificationIcon from '../svgs/NotificationIcon'

import { AppServices, registerAppServices } from './types'
import { handleSound } from './utils'

const BASE_NOTIF_OPTIONS: Partial<NotificationOptions> = {
  icon: NotificationIcon
}

const webAppServices: AppServices = {
  notifications: {
    sendNotification: (notif: ConversationNotification) => {
      if (!Notification) {
        return Promise.reject(new Error('Notifications not supported'))
      }
      const n = new Notification(notif.title, {
        ...BASE_NOTIF_OPTIONS,
        body: notif.body,
        tag: notif.tag
      })

      handleSound(notif)

      n.onclick = function(event) {
        if (event) {
          event.preventDefault()
        }
        window.focus()
      }

      return Promise.resolve()
    },
    sendABMNotification: (notif: ABMNotification) => {
      const n = new Notification(notif.title, {
        ...BASE_NOTIF_OPTIONS,
        body: notif.body,
        tag: notif.ABMData?.endUserId + ''
      })
      handleSound(notif)
      n.onclick = function(event) {
        if (event) {
          event.preventDefault()
        }
        window.focus()
      }
      return Promise.resolve()
    },
    sendExternalNotification: (notif: ExternalNotification) => {
      const n = new Notification(notif.title, {
        ...BASE_NOTIF_OPTIONS,
        body: notif.body,
        tag: notif.title
      })
      handleSound(notif)

      n.onclick = function(event) {
        if (event) {
          event.preventDefault()
        }
        window.open(notif.onClickUrl)
      }
      return Promise.resolve()
    }
  },
  badges: {
    showBadgeIconNumber: () => Promise.resolve(),
    isWindowVisible: () => new Promise(resolve => resolve(document.hasFocus()))
  },
  auth: {
    openWebLogin: () => webAuthRedirect(config.CLIENT_ID),
    logout: async () => {
      window.history.pushState({}, '', '/')
      webAuthRedirect(config.CLIENT_ID)
    }
  },
  util: {
    log: (entry: any) => {
      if (isDev) {
        // eslint-disable-next-line no-console
        console.log(entry.message)
      }
    }
  },
  reload: {
    reloadApplication: () => window.location.reload()
  },
  redux: {
    sendAction: () => {}
  }
}

export const registerWebAppServices = () => {
  registerAppServices(webAppServices)
}
